// Special characters allowed in passwords (character class only)
const SPECIAL_CHARS_CLASS = '[-+_!@#$%^&*.,?]';

/**
 * Regex requiring at least one allowed special character.
 *
 * Business rules:
 * - Must stay in sync with `isSpecialChar` and Yup validation rules.
 *
 * `@example`
 * SPECIAL_CHARS_REGEX.test('Abc!123') // true
 *
 * `@see` isSpecialChar
 * `@see` app/src/pages/auth/set-cognito-password.tsx
 */
export const SPECIAL_CHARS_REGEX = new RegExp(`^(?=.*${SPECIAL_CHARS_CLASS}).+$`);

export function isNumber(value: string): boolean {
  return new RegExp('^(?=.*[0-9]).+$').test(value);
}

export function isLowercaseChar(value: string): boolean {
  return new RegExp('^(?=.*[a-z]).+$').test(value);
}

export function isUppercaseChar(value: string): boolean {
  return new RegExp('^(?=.*[A-Z]).+$').test(value);
}

export function isSpecialChar(value: string): boolean {
  return SPECIAL_CHARS_REGEX.test(value);
}

export function minLength(value: string): boolean {
  return value.length > 7;
}

export function minLength12(value: string): boolean {
  return value.length >= 12;
}

export function hasNoSpaces(value: string): boolean {
  return !/\s/.test(value);
}
